/**
 * Earn Defera Credit API calls (server/earn-credit.js). Every call carries
 * the signed-in session; errors throw with the server's own message, which is
 * written to be shown as-is.
 */
import { supabase } from '@/lib/supabase';
import { getApiUrl } from '@/lib/apiUrls';

async function call(path, { method = 'GET', body } = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    const err = new Error('Please sign in.');
    err.status = 401;
    throw err;
  }
  const res = await fetch(getApiUrl(path), {
    method,
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      ...(body ? { 'Content-Type': 'application/json' } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error || 'Something went wrong. Try again in a moment.');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const earnCreditApi = {
  overview: () => call('earn-credit'),
  submit: (body) => call('earn-credit/submissions', { method: 'POST', body }),
  withdraw: (id) => call(`earn-credit/submissions/${id}/withdraw`, { method: 'POST' }),
  queue: (status) => call(`admin/earn-credit/submissions?status=${encodeURIComponent(status)}`),
  approve: (id) => call(`admin/earn-credit/submissions/${id}/approve`, { method: 'POST' }),
  decline: (id, reason) => call(`admin/earn-credit/submissions/${id}/decline`, { method: 'POST', body: { reason } }),
};
